<template>
  <div class="flex items-center gap-2 mr-2">
    <VaButton size="small" color="success" text-color="#ffffff" class="mis-proyectos p-2" @click="createBusiness">
      Mis Proyectos
    </VaButton>
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
const router = useRouter()

function createBusiness() {
  router.push({ name: 'workspace' })
}
</script>

<style scoped>
.mis-proyectos {
  color: #ffffff;
}

.mis-proyectos :deep(.va-button__content) {
  color: #ffffff;
}

.workspace-select {
  width: min(190px, 32vw);
  --va-input-wrapper-background: white;
}
</style>
